module.exports = __webpack_public_path__ + "img/claim-flag-update.754f00d7.svg";